import React from "react";
import Card from "react-bootstrap/Card";
import ListGroup from "react-bootstrap/ListGroup";
import Alert from "react-bootstrap/Alert";
import Spinner from "react-bootstrap/Spinner";
import "./NotificationContainer.css";
import Notification from "../../components/Notification/Notification";
import {
  loadNotiRequestAction,
  delNotiRequestAction
} from "../../redux/actions/notification";
import { connect } from "react-redux";
import { toast } from "react-toastify";
import { withCookies } from "react-cookie";

class NotificationContainer extends React.Component {
  constructor(props) {
    super(props);
    this.handleClose = this.handleClose.bind(this);
  }

  componentDidMount() {
    if (!this.props.loaded) {
      this.props.loadNotiRequestAction();
    }
  }

  handleClose(notificationID) {
    this.props.delNotiRequestAction(notificationID, toast);
  }

  renderSwitch() {
    if (!this.props.loaded) {
      return (
        <div className="noti_load">
          <Spinner animation="grow" />
        </div>
      );
    } else if (this.props.errMsg != null) {
      return (
        <Alert variant="danger" className="noti_error">
          {this.props.errMsg}
        </Alert>
      );
    } else if (this.props.notifications.length > 0) {
      const { cookies } = this.props;
      const isAdmin = cookies.get("role") === "admin";

      return (
        <ListGroup variant="flush">
          {this.props.notifications.map(notification => (
            <Notification
              key={notification.id}
              notification={notification}
              onClose={this.handleClose}
              isAdmin={isAdmin}
            />
          ))}
        </ListGroup>
      );
    } else {
      return <span className="no_noti">None</span>;
    }
  }

  render() {
    return (
      <Card className="notification_container" bg="light">
        <Card.Header>Notifications</Card.Header>
        {this.renderSwitch()}
      </Card>
    );
  }
}

const mapState = state => {
  const { notification } = state;
  return notification;
};

const mapDispatch = {
  loadNotiRequestAction,
  delNotiRequestAction
};

export default withCookies(
  connect(
    mapState,
    mapDispatch
  )(NotificationContainer)
);
